/* sucrase/dist/esm/parser/tokenizer/types.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.formatTokenType = formatTokenType;
    (function (TokenType) {
        // Precedence 0 means not an operator; otherwise it is a positive number up to 12.
        const PRECEDENCE_MASK = 0xf;
        TokenType[TokenType["PRECEDENCE_MASK"] = PRECEDENCE_MASK] = "PRECEDENCE_MASK";
        const IS_KEYWORD = 1 << 4;
        TokenType[TokenType["IS_KEYWORD"] = IS_KEYWORD] = "IS_KEYWORD";
        const IS_ASSIGN = 1 << 5;
        TokenType[TokenType["IS_ASSIGN"] = IS_ASSIGN] = "IS_ASSIGN";
        const IS_RIGHT_ASSOCIATIVE = 1 << 6;
        TokenType[TokenType["IS_RIGHT_ASSOCIATIVE"] = IS_RIGHT_ASSOCIATIVE] = "IS_RIGHT_ASSOCIATIVE";
        const IS_PREFIX = 1 << 7;
        TokenType[TokenType["IS_PREFIX"] = IS_PREFIX] = "IS_PREFIX";
        const IS_POSTFIX = 1 << 8;
        TokenType[TokenType["IS_POSTFIX"] = IS_POSTFIX] = "IS_POSTFIX";
        const IS_EXPRESSION_START = 1 << 9;
        TokenType[TokenType["IS_EXPRESSION_START"] = IS_EXPRESSION_START] = "IS_EXPRESSION_START";
        const num = 512;
        TokenType[TokenType["num"] = num] = "num"; // num startsExpr
        const bigint = 1536;
        TokenType[TokenType["bigint"] = bigint] = "bigint"; // bigint startsExpr
        const decimal = 2560;
        TokenType[TokenType["decimal"] = decimal] = "decimal"; // decimal startsExpr
        const regexp = 3584;
        TokenType[TokenType["regexp"] = regexp] = "regexp"; // regexp startsExpr
        const string = 4608;
        TokenType[TokenType["string"] = string] = "string"; // string startsExpr
        const name = 5632;
        TokenType[TokenType["name"] = name] = "name"; // name startsExpr
        const eof = 6144;
        TokenType[TokenType["eof"] = eof] = "eof"; // eof
        const bracketL = 7680;
        TokenType[TokenType["bracketL"] = bracketL] = "bracketL"; // [ startsExpr
        const bracketR = 8192;
        TokenType[TokenType["bracketR"] = bracketR] = "bracketR"; // ]
        const braceL = 9728;
        TokenType[TokenType["braceL"] = braceL] = "braceL"; // { startsExpr
        const braceBarL = 10752;
        TokenType[TokenType["braceBarL"] = braceBarL] = "braceBarL"; // {| startsExpr
        const braceR = 11264;
        TokenType[TokenType["braceR"] = braceR] = "braceR"; // }
        const braceBarR = 12288;
        TokenType[TokenType["braceBarR"] = braceBarR] = "braceBarR"; // |}
        const parenL = 13824;
        TokenType[TokenType["parenL"] = parenL] = "parenL"; // ( startsExpr
        const parenR = 14336;
        TokenType[TokenType["parenR"] = parenR] = "parenR"; // )
        const comma = 15360;
        TokenType[TokenType["comma"] = comma] = "comma"; // ,
        const semi = 16384;
        TokenType[TokenType["semi"] = semi] = "semi"; // ;
        const colon = 17408;
        TokenType[TokenType["colon"] = colon] = "colon"; // :
        const doubleColon = 18432;
        TokenType[TokenType["doubleColon"] = doubleColon] = "doubleColon"; // ::
        const dot = 19456;
        TokenType[TokenType["dot"] = dot] = "dot"; // .
        const question = 20480;
        TokenType[TokenType["question"] = question] = "question"; // ?
        const questionDot = 21504;
        TokenType[TokenType["questionDot"] = questionDot] = "questionDot"; // ?.
        const arrow = 22528;
        TokenType[TokenType["arrow"] = arrow] = "arrow"; // =>
        const template = 23552;
        TokenType[TokenType["template"] = template] = "template"; // template
        const ellipsis = 24576;
        TokenType[TokenType["ellipsis"] = ellipsis] = "ellipsis"; // ...
        const backQuote = 25600;
        TokenType[TokenType["backQuote"] = backQuote] = "backQuote"; // `
        const dollarBraceL = 27136;
        TokenType[TokenType["dollarBraceL"] = dollarBraceL] = "dollarBraceL"; // ${ startsExpr
        const at = 27648;
        TokenType[TokenType["at"] = at] = "at"; // @
        const hash = 29184;
        TokenType[TokenType["hash"] = hash] = "hash"; // # startsExpr
        const eq = 29728;
        TokenType[TokenType["eq"] = eq] = "eq"; // = isAssign
        const assign = 30752;
        TokenType[TokenType["assign"] = assign] = "assign"; // _= isAssign
        const preIncDec = 32640;
        TokenType[TokenType["preIncDec"] = preIncDec] = "preIncDec"; // ++/-- prefix postfix startsExpr
        const postIncDec = 33664;
        TokenType[TokenType["postIncDec"] = postIncDec] = "postIncDec"; // ++/-- prefix postfix startsExpr
        const bang = 34432;
        TokenType[TokenType["bang"] = bang] = "bang"; // ! prefix startsExpr
        const tilde = 35456;
        TokenType[TokenType["tilde"] = tilde] = "tilde"; // ~ prefix startsExpr
        const pipeline = 35841;
        TokenType[TokenType["pipeline"] = pipeline] = "pipeline"; // |> prec:1
        const nullishCoalescing = 36866;
        TokenType[TokenType["nullishCoalescing"] = nullishCoalescing] = "nullishCoalescing"; // ?? prec:2
        const logicalOR = 37890;
        TokenType[TokenType["logicalOR"] = logicalOR] = "logicalOR"; // || prec:2
        const logicalAND = 38915;
        TokenType[TokenType["logicalAND"] = logicalAND] = "logicalAND"; // && prec:3
        const bitwiseOR = 39940;
        TokenType[TokenType["bitwiseOR"] = bitwiseOR] = "bitwiseOR"; // | prec:4
        const bitwiseXOR = 40965;
        TokenType[TokenType["bitwiseXOR"] = bitwiseXOR] = "bitwiseXOR"; // ^ prec:5
        const bitwiseAND = 41990;
        TokenType[TokenType["bitwiseAND"] = bitwiseAND] = "bitwiseAND"; // & prec:6
        const equality = 43015;
        TokenType[TokenType["equality"] = equality] = "equality"; // ==/!= prec:7
        const lessThan = 44040;
        TokenType[TokenType["lessThan"] = lessThan] = "lessThan"; // < prec:8
        const greaterThan = 45064;
        TokenType[TokenType["greaterThan"] = greaterThan] = "greaterThan"; // > prec:8
        const relationalOrEqual = 46088;
        TokenType[TokenType["relationalOrEqual"] = relationalOrEqual] = "relationalOrEqual"; // <=/>= prec:8
        const bitShiftL = 47113;
        TokenType[TokenType["bitShiftL"] = bitShiftL] = "bitShiftL"; // << prec:9
        const bitShiftR = 48137;
        TokenType[TokenType["bitShiftR"] = bitShiftR] = "bitShiftR"; // >>/>>> prec:9
        const plus = 49802;
        TokenType[TokenType["plus"] = plus] = "plus"; // + prec:10 prefix startsExpr
        const minus = 50826;
        TokenType[TokenType["minus"] = minus] = "minus"; // - prec:10 prefix startsExpr
        const modulo = 51723;
        TokenType[TokenType["modulo"] = modulo] = "modulo"; // % prec:11 startsExpr
        const star = 52235;
        TokenType[TokenType["star"] = star] = "star"; // * prec:11
        const slash = 53259;
        TokenType[TokenType["slash"] = slash] = "slash"; // / prec:11
        const exponent = 54348;
        TokenType[TokenType["exponent"] = exponent] = "exponent"; // ** prec:12 rightAssociative
        const jsxName = 55296;
        TokenType[TokenType["jsxName"] = jsxName] = "jsxName"; // jsxName
        const jsxText = 56320;
        TokenType[TokenType["jsxText"] = jsxText] = "jsxText"; // jsxText
        const jsxEmptyText = 57344;
        TokenType[TokenType["jsxEmptyText"] = jsxEmptyText] = "jsxEmptyText"; // jsxEmptyText
        const jsxTagStart = 58880;
        TokenType[TokenType["jsxTagStart"] = jsxTagStart] = "jsxTagStart"; // jsxTagStart startsExpr
        const jsxTagEnd = 59392;
        TokenType[TokenType["jsxTagEnd"] = jsxTagEnd] = "jsxTagEnd"; // jsxTagEnd
        const typeParameterStart = 60928;
        TokenType[TokenType["typeParameterStart"] = typeParameterStart] = "typeParameterStart"; // typeParameterStart startsExpr
        const nonNullAssertion = 61440;
        TokenType[TokenType["nonNullAssertion"] = nonNullAssertion] = "nonNullAssertion"; // nonNullAssertion
        const _break = 62480;
        TokenType[TokenType["_break"] = _break] = "_break"; // break keyword
        const _case = 63504;
        TokenType[TokenType["_case"] = _case] = "_case"; // case keyword
        const _catch = 64528;
        TokenType[TokenType["_catch"] = _catch] = "_catch"; // catch keyword
        const _continue = 65552;
        TokenType[TokenType["_continue"] = _continue] = "_continue"; // continue keyword
        const _debugger = 66576;
        TokenType[TokenType["_debugger"] = _debugger] = "_debugger"; // debugger keyword
        const _default = 67600;
        TokenType[TokenType["_default"] = _default] = "_default"; // default keyword
        const _do = 68624;
        TokenType[TokenType["_do"] = _do] = "_do"; // do keyword
        const _else = 69648;
        TokenType[TokenType["_else"] = _else] = "_else"; // else keyword
        const _finally = 70672;
        TokenType[TokenType["_finally"] = _finally] = "_finally"; // finally keyword
        const _for = 71696;
        TokenType[TokenType["_for"] = _for] = "_for"; // for keyword
        const _function = 73232;
        TokenType[TokenType["_function"] = _function] = "_function"; // function keyword startsExpr
        const _if = 73744;
        TokenType[TokenType["_if"] = _if] = "_if"; // if keyword
        const _return = 74768;
        TokenType[TokenType["_return"] = _return] = "_return"; // return keyword
        const _switch = 75792;
        TokenType[TokenType["_switch"] = _switch] = "_switch"; // switch keyword
        const _throw = 77456;
        TokenType[TokenType["_throw"] = _throw] = "_throw"; // throw keyword prefix startsExpr
        const _try = 77840;
        TokenType[TokenType["_try"] = _try] = "_try"; // try keyword
        const _var = 78864;
        TokenType[TokenType["_var"] = _var] = "_var"; // var keyword
        const _let = 79888;
        TokenType[TokenType["_let"] = _let] = "_let"; // let keyword
        const _const = 80912;
        TokenType[TokenType["_const"] = _const] = "_const"; // const keyword
        const _while = 81936;
        TokenType[TokenType["_while"] = _while] = "_while"; // while keyword
        const _with = 82960;
        TokenType[TokenType["_with"] = _with] = "_with"; // with keyword
        const _new = 84496;
        TokenType[TokenType["_new"] = _new] = "_new"; // new keyword startsExpr
        const _this = 85520;
        TokenType[TokenType["_this"] = _this] = "_this"; // this keyword startsExpr
        const _super = 86544;
        TokenType[TokenType["_super"] = _super] = "_super"; // super keyword startsExpr
        const _class = 87568;
        TokenType[TokenType["_class"] = _class] = "_class"; // class keyword startsExpr
        const _extends = 88080;
        TokenType[TokenType["_extends"] = _extends] = "_extends"; // extends keyword
        const _export = 89104;
        TokenType[TokenType["_export"] = _export] = "_export"; // export keyword
        const _import = 90640;
        TokenType[TokenType["_import"] = _import] = "_import"; // import keyword startsExpr
        const _yield = 91664;
        TokenType[TokenType["_yield"] = _yield] = "_yield"; // yield keyword startsExpr
        const _null = 92688;
        TokenType[TokenType["_null"] = _null] = "_null"; // null keyword startsExpr
        const _true = 93712;
        TokenType[TokenType["_true"] = _true] = "_true"; // true keyword startsExpr
        const _false = 94736;
        TokenType[TokenType["_false"] = _false] = "_false"; // false keyword startsExpr
        const _in = 95256;
        TokenType[TokenType["_in"] = _in] = "_in"; // in prec:8 keyword
        const _instanceof = 96280;
        TokenType[TokenType["_instanceof"] = _instanceof] = "_instanceof"; // instanceof prec:8 keyword
        const _typeof = 97936;
        TokenType[TokenType["_typeof"] = _typeof] = "_typeof"; // typeof keyword prefix startsExpr
        const _void = 98960;
        TokenType[TokenType["_void"] = _void] = "_void"; // void keyword prefix startsExpr
        const _delete = 99984;
        TokenType[TokenType["_delete"] = _delete] = "_delete"; // delete keyword prefix startsExpr
        const _async = 100880;
        TokenType[TokenType["_async"] = _async] = "_async"; // async keyword startsExpr
        const _get = 101904;
        TokenType[TokenType["_get"] = _get] = "_get"; // get keyword startsExpr
        const _set = 102928;
        TokenType[TokenType["_set"] = _set] = "_set"; // set keyword startsExpr
        const _declare = 103952;
        TokenType[TokenType["_declare"] = _declare] = "_declare"; // declare keyword startsExpr
        const _readonly = 104976;
        TokenType[TokenType["_readonly"] = _readonly] = "_readonly"; // readonly keyword startsExpr
        const _abstract = 106000;
        TokenType[TokenType["_abstract"] = _abstract] = "_abstract"; // abstract keyword startsExpr
        const _static = 107024;
        TokenType[TokenType["_static"] = _static] = "_static"; // static keyword startsExpr
        const _public = 107536;
        TokenType[TokenType["_public"] = _public] = "_public"; // public keyword
        const _private = 108560;
        TokenType[TokenType["_private"] = _private] = "_private"; // private keyword
        const _protected = 109584;
        TokenType[TokenType["_protected"] = _protected] = "_protected"; // protected keyword
        const _override = 110608;
        TokenType[TokenType["_override"] = _override] = "_override"; // override keyword
        const _as = 112144;
        TokenType[TokenType["_as"] = _as] = "_as"; // as keyword startsExpr
        const _enum = 113168;
        TokenType[TokenType["_enum"] = _enum] = "_enum"; // enum keyword startsExpr
        const _type = 114192;
        TokenType[TokenType["_type"] = _type] = "_type"; // type keyword startsExpr
        const _implements = 115216;
        TokenType[TokenType["_implements"] = _implements] = "_implements"; // implements keyword startsExpr
    })(exports.TokenType || (exports.TokenType = {}));
    function formatTokenType(tokenType) {
        switch (tokenType) {
            case exports.TokenType.num:
                return "num";
            case exports.TokenType.bigint:
                return "bigint";
            case exports.TokenType.decimal:
                return "decimal";
            case exports.TokenType.regexp:
                return "regexp";
            case exports.TokenType.string:
                return "string";
            case exports.TokenType.name:
                return "name";
            case exports.TokenType.eof:
                return "eof";
            case exports.TokenType.bracketL:
                return "[";
            case exports.TokenType.bracketR:
                return "]";
            case exports.TokenType.braceL:
                return "{";
            case exports.TokenType.braceBarL:
                return "{|";
            case exports.TokenType.braceR:
                return "}";
            case exports.TokenType.braceBarR:
                return "|}";
            case exports.TokenType.parenL:
                return "(";
            case exports.TokenType.parenR:
                return ")";
            case exports.TokenType.comma:
                return ",";
            case exports.TokenType.semi:
                return ";";
            case exports.TokenType.colon:
                return ":";
            case exports.TokenType.doubleColon:
                return "::";
            case exports.TokenType.dot:
                return ".";
            case exports.TokenType.question:
                return "?";
            case exports.TokenType.questionDot:
                return "?.";
            case exports.TokenType.arrow:
                return "=>";
            case exports.TokenType.template:
                return "template";
            case exports.TokenType.ellipsis:
                return "...";
            case exports.TokenType.backQuote:
                return "`";
            case exports.TokenType.dollarBraceL:
                return "${";
            case exports.TokenType.at:
                return "@";
            case exports.TokenType.hash:
                return "#";
            case exports.TokenType.eq:
                return "=";
            case exports.TokenType.assign:
                return "_=";
            case exports.TokenType.preIncDec:
                return "++/--";
            case exports.TokenType.postIncDec:
                return "++/--";
            case exports.TokenType.bang:
                return "!";
            case exports.TokenType.tilde:
                return "~";
            case exports.TokenType.pipeline:
                return "|>";
            case exports.TokenType.nullishCoalescing:
                return "??";
            case exports.TokenType.logicalOR:
                return "||";
            case exports.TokenType.logicalAND:
                return "&&";
            case exports.TokenType.bitwiseOR:
                return "|";
            case exports.TokenType.bitwiseXOR:
                return "^";
            case exports.TokenType.bitwiseAND:
                return "&";
            case exports.TokenType.equality:
                return "==/!=";
            case exports.TokenType.lessThan:
                return "<";
            case exports.TokenType.greaterThan:
                return ">";
            case exports.TokenType.relationalOrEqual:
                return "<=/>=";
            case exports.TokenType.bitShiftL:
                return "<<";
            case exports.TokenType.bitShiftR:
                return ">>/>>>";
            case exports.TokenType.plus:
                return "+";
            case exports.TokenType.minus:
                return "-";
            case exports.TokenType.modulo:
                return "%";
            case exports.TokenType.star:
                return "*";
            case exports.TokenType.slash:
                return "/";
            case exports.TokenType.exponent:
                return "**";
            case exports.TokenType.jsxName:
                return "jsxName";
            case exports.TokenType.jsxText:
                return "jsxText";
            case exports.TokenType.jsxEmptyText:
                return "jsxEmptyText";
            case exports.TokenType.jsxTagStart:
                return "jsxTagStart";
            case exports.TokenType.jsxTagEnd:
                return "jsxTagEnd";
            case exports.TokenType.typeParameterStart:
                return "typeParameterStart";
            case exports.TokenType.nonNullAssertion:
                return "nonNullAssertion";
            case exports.TokenType._break:
                return "break";
            case exports.TokenType._case:
                return "case";
            case exports.TokenType._catch:
                return "catch";
            case exports.TokenType._continue:
                return "continue";
            case exports.TokenType._debugger:
                return "debugger";
            case exports.TokenType._default:
                return "default";
            case exports.TokenType._do:
                return "do";
            case exports.TokenType._else:
                return "else";
            case exports.TokenType._finally:
                return "finally";
            case exports.TokenType._for:
                return "for";
            case exports.TokenType._function:
                return "function";
            case exports.TokenType._if:
                return "if";
            case exports.TokenType._return:
                return "return";
            case exports.TokenType._switch:
                return "switch";
            case exports.TokenType._throw:
                return "throw";
            case exports.TokenType._try:
                return "try";
            case exports.TokenType._var:
                return "var";
            case exports.TokenType._let:
                return "let";
            case exports.TokenType._const:
                return "const";
            case exports.TokenType._while:
                return "while";
            case exports.TokenType._with:
                return "with";
            case exports.TokenType._new:
                return "new";
            case exports.TokenType._this:
                return "this";
            case exports.TokenType._super:
                return "super";
            case exports.TokenType._class:
                return "class";
            case exports.TokenType._extends:
                return "extends";
            case exports.TokenType._export:
                return "export";
            case exports.TokenType._import:
                return "import";
            case exports.TokenType._yield:
                return "yield";
            case exports.TokenType._null:
                return "null";
            case exports.TokenType._true:
                return "true";
            case exports.TokenType._false:
                return "false";
            case exports.TokenType._in:
                return "in";
            case exports.TokenType._instanceof:
                return "instanceof";
            case exports.TokenType._typeof:
                return "typeof";
            case exports.TokenType._void:
                return "void";
            case exports.TokenType._delete:
                return "delete";
            case exports.TokenType._async:
                return "async";
            case exports.TokenType._get:
                return "get";
            case exports.TokenType._set:
                return "set";
            case exports.TokenType._declare:
                return "declare";
            case exports.TokenType._readonly:
                return "readonly";
            case exports.TokenType._abstract:
                return "abstract";
            case exports.TokenType._static:
                return "static";
            case exports.TokenType._public:
                return "public";
            case exports.TokenType._private:
                return "private";
            case exports.TokenType._protected:
                return "protected";
            case exports.TokenType._override:
                return "override";
            case exports.TokenType._as:
                return "as";
            case exports.TokenType._enum:
                return "enum";
            case exports.TokenType._type:
                return "type";
            case exports.TokenType._implements:
                return "implements";
            default:
                return "";
        }
    }
}
